import { render } from "./AreaCouponsList.vue?vue&type=template&id=2e104ff4"
import script from "./AreaCouponsList.vue?vue&type=script&lang=js"
export * from "./AreaCouponsList.vue?vue&type=script&lang=js"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__